import { createContext } from 'react';

const CommonContext = createContext(null);
export default CommonContext;
